import suggestedUsersState from './suggested-users/state'
import suggestedUsersMutations from './suggested-users/mutations'
import suggestedUsersActions from './suggested-users/actions'


export default {
    state: {
        ...suggestedUsersState
    },
    mutations: {
        ...suggestedUsersMutations
    },
    actions: {
        ...suggestedUsersActions
    },
    getters: {

    }
}